export default __webpack_public_path__ + "static/media/dvalins_claw.ac2c45a7.png";